import { useContext, useMemo } from "react";
import { StepsManagerContext } from "../contexts/StepsManager";
import { CreateMissionScreensContext } from "../contexts/CreateMissionManager";
import { MissionScreens } from "../navigations/CreateMissionStack";

type UseBubbleStepOriginParams = MissionScreens;

export const useBubbleStepOrigin = (currentStepName: UseBubbleStepOriginParams) => {
    const { currentStepIndex } = useContext(CreateMissionScreensContext);
    const { stepsX } = useContext(StepsManagerContext);

    const origin = useMemo<[number, number]>(() => {
        if (!stepsX || !currentStepIndex) {
            // used in testing where the context is not available
            // 20 is just to have a little space from the box upper left corner
            return [20, 0];
        }
        return [stepsX[currentStepIndex(currentStepName) || 0], 0];
    }, [currentStepIndex, currentStepName, stepsX]);

    return origin;
};
